/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from "react";
import {
  Row,
  Col,
  CardText,
  CardTitle,
  Card,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { Link } from "react-router-dom";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { MdLocationOn, MdOutlineFeedback } from "react-icons/md";
import SelectRouteModal from "../../../../components/Modals/SelectRouteModal";
import ShareModal from "../../../../components/Modals/ShareModal";
import ReportSuggestionModal from "../../../../components/Modals/ReportSuggestionModal";
import CreateNewRouteModal from "../../../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../../../components/Modals/PointsListingModal";
import Pagination from "../../../../components/Pagination/Pagination";
import NoDataFound from "../../../../components/NoDataFound/NoDataFound";
import "../Cemetery.scss";
import {
  routeDetail,
  updateRouteDetail,
} from "../../../../services/myRoute.service";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  IoHeartOutline,
  IoHeartSharp,
  IoNavigateSharp,
  IoShareSocial,
} from "react-icons/io5";
import { HiDotsVertical } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";
// import card_image from "../../../../assets/card_image.png";
import { FaLocationDot } from "react-icons/fa6";
import "./gridview.scss";
import { API_URL } from "../../../../config/config";
import { categoryItems } from "../../../Home/Category";

const GridView = ({
  name,
  categoryTitle,
  categoryIcon,
  categoryItem,
  totalCount,
  currentPage,
  setCurrentPage,
  pageSize,
  addToFavorite,
  removeFromFavorite,
}) => {
  const [dropdownMenuOpen, setMenuOpen] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [route, setRoute] = useState(null);
  const [mkmID, setMkmId] = useState();
  const [routeName, setRouteName] = useState(null);
  const [totalRecords, setTotalRecords] = useState("");
  const [pointName, setPointName] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [link, setLink] = useState("");

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };

  useEffect(() => {
    setTotalRecords(totalCount);

    console.log("all data", categoryItem);
  }, [totalCount]);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return categoryItem?.slice(0, pageSize);
  }, [currentPage, categoryItem]);

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
    console.log("pointName", pointName);
  };

  const addToRoute = (id, name) => {
    console.log("place to add.........", id);
    setMkmId(id);
    setPointName(name);
    console.log("pointName", pointName);
    setShowModal(true);
  };

  const share = (id, poi) => {
    var data;
    if (name === "Tzadikim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id}/${poi}`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }
        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            setShowSpinner(true);
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowSpinner(false);
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              }
            );
            setShowSpinner(false);
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
          setShowSpinner(false);
        }
        setRoute("");
        setShowModal(false);
      } catch (error) {
        console.log(error);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setShowSpinner(false);
    }
  };

  return (
    <div className="grid_view">
      <SelectRouteModal
        route={route}
        setRoute={setRoute}
        showModal={showModal}
        toggle={toggle}
        createNewRoute={createNewRoute}
        selectRoute={selectRoute}
        showSpinner={showSpinner}
      />
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        mkmID={mkmID}
      />
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />

      <div
        className={`item_card ${
          currentTableData?.length <= 2 ? "two-items" : ""
        }`}
      >
        {currentTableData?.length === 0 || currentTableData === undefined ? (
          <NoDataFound />
        ) : (
          currentTableData?.map((place, index) => (
            <div className="grid_card">
              <Link
                to={
                  name === "Tzadikim"
                    ? `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`
                    : `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`
                }
                state={{
                  categoryName: name,
                  categoryTitle: categoryTitle,
                  categoryIcon: categoryIcon,
                }}
              >
                <div className="card_items">
                  <div className="card_image">
                    <img
                      src={
                        place?.imageIDs?.length > 0
                          ? `${API_URL}/api/mkm/getimage/${place?.imageIDs?.[0]}`
                          : categoryItems.find(
                              (item) => item.showTitle === categoryTitle
                            )?.icon
                      }
                      alt="placeholder"
                    />
                  </div>
                  <div className="like_list">
                    <div className="like_icon">
                      {place?.userFavorite === true ? (
                        <div
                          style={{ color: "#F57D2B" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            removeFromFavorite(
                              place?.tzadikimID
                                ? { tzadikimID: place?.tzadikimID }
                                : { mkmID: place?.mkmID },
                              place?.userFavorite
                            );
                          }}
                        >
                          {" "}
                          <IoHeartSharp size="22px" />
                        </div>
                      ) : (
                        <div
                          style={{ color: "#787776" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            addToFavorite(
                              place?.tzadikimID
                                ? { tzadikimID: place?.tzadikimID }
                                : { mkmID: place?.mkmID },
                              place?.userFavorite
                            );
                          }}
                        >
                          {" "}
                          <IoHeartOutline size="22px" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="dropdown_list">
                    <Dropdown
                      className="moreInfo"
                      toggle={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setMenuOpen(index === dropdownMenuOpen ? null : index);
                      }}
                      isOpen={index === dropdownMenuOpen}
                    >
                      <DropdownToggle className="list_icon" caret={false}>
                        <HiDotsVertical className="list" />
                      </DropdownToggle>

                      <DropdownMenu
                        className="custom_dropdown"
                        modifiers={[
                          {
                            name: "offset",
                            options: {
                              offset: [-140, 5],
                            },
                          },
                        ]}
                      >
                        <DropdownItem>
                          <Link
                            to={`/along-the-way-to-here/${place?.poi}`}
                            state={{
                              categoryName: name,
                              categoryTitle: categoryTitle,
                              categoryIcon: categoryIcon,
                            }}
                            className="breadcrumb_item1"
                          >
                            <IoNavigateSharp
                              className="navigate_icon"
                              size={"18px"}
                            />
                            <span>Along the way to here</span>
                          </Link>
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            reportSuggestion(
                              place?.title,
                              place?.tzadikimID
                                ? place?.tzadikimID
                                : place?.mkmID
                            )
                          }
                        >
                          <MdOutlineFeedback />
                          Report suggestion
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="card_top">
                    <div
                      className="left_section"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        share(
                          place?.tzadikimID ? place?.tzadikimID : place?.mkmID,
                          place?.poi
                        );
                      }}
                    >
                      <IoShareSocial />
                    </div>
                    <div className="right_section">
                      <Link
                        to={
                          name === "Tzadikim"
                            ? `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`
                            : `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`
                        }
                        state={{
                          categoryName: name,
                          categoryTitle: categoryTitle,
                          categoryIcon: categoryIcon,
                        }}
                      >
                        <h3 className="card_title" title={place?.title}>
                          {place?.title}
                        </h3>
                      </Link>
                      <h4>
                        {" "}
                        {place?.cityY
                          ? place?.cityY.substring(
                              place?.cityY.indexOf("/") + 1
                            )
                          : null}
                        {place?.stateY
                          ? " - " +
                            place?.stateY.substring(
                              place?.stateY.indexOf("/") + 1
                            )
                          : null}
                      </h4>
                    </div>
                  </div>
                  <div className="card_location">
                    <div className="location_icon">
                      <FaLocationDot />
                    </div>
                    <div className="place_name">
                      {place?.cityE + " " + place?.stateE}
                    </div>
                  </div>

                  <div className="card_buttons">
                    <Button
                      className="btn_explore"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Link
                        style={{ color: "#F57D2B" }}
                        to={`/explore-near-by/${place?.poi}`}
                        state={{
                          categoryName: name,
                          categoryTitle: categoryTitle,
                          categoryIcon: categoryIcon,
                        }}
                      >
                        Explore Near By
                      </Link>
                    </Button>

                    <Link
                      className="btns_viewmore"
                      to={
                        name === "Tzadikim"
                          ? `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`
                          : `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`
                      }
                      state={{
                        categoryName: name,
                        categoryTitle: categoryTitle,
                        categoryIcon: categoryIcon,
                        poi: place?.poi,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      View More
                    </Link>
                    <Button
                      className="btn_addroute"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        addToRoute(place?.mkmID, place);
                      }}
                    >
                      <FaPlus className="addroute_icon" />
                      Add to Route
                    </Button>
                  </div>
                </div>
              </Link>
            </div>
          ))
        )}
      </div>
      {currentTableData?.length === 0 ||
      currentTableData === undefined ? null : (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalRecords > 0 ? totalRecords : null}
          pageSize={pageSize}
          onPageChange={(page) => {
            setCurrentPage(page);
            window.scrollTo({ top: 0, behavior: "instant" });
          }}
        />
      )}
    </div>
  );
};

export default GridView;
